module.exports = __webpack_public_path__ + "img/art.18c81acb.png";